"use client";
import ScrollTriggeredSwiperSection, {
  ScrollTriggeredSwiperSectionProps,
} from "@/commonComponents/scrollTriggeredSwiperSection";
import { H6_2 } from "@/styles/theme/components/typography.fontvariant";

export interface CharitableTrustsStoriesProps {
  data: ScrollTriggeredSwiperSectionProps["data"];
  navId?: string;
}

const CharitableTrustsStories = (props: CharitableTrustsStoriesProps) => {
  const { data, navId } = props;
  return (
    <ScrollTriggeredSwiperSection
      data={data}
      navId={navId || "stories"}
      EnhancedSwiperProps={{
        SlideComponentProps: {
          DescriptionTypographyProps: {
            fontSize: H6_2,
            sx: {
              opacity: 1,
              textAlign:'justify'
            },
          },
        },
      }}
    />
  );
};

export default CharitableTrustsStories;
